import React from 'react';
import '../../styles/components/TablaTiposCambio.css';

const formatearValor = (valor) =>
    Number(valor).toLocaleString('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 4 });

// AAAA-MM-DD → DD-MM-AAAA, sin pasar por Date para no correr la fecha por la zona horaria
const formatearFecha = (iso) => (iso ? iso.split('-').reverse().join('-') : '');

/**
 * Tabla de tasas al 31-12 de un año (módulo Inversiones exterior).
 * La usan la consulta de las empresas y el panel de EFE; con onCorregir
 * (solo en el panel) muestra el botón Corregir en cada fila.
 *
 * @param {Object} props
 * @param {Array} props.tasas - Tasas del año
 * @param {Function} [props.onCorregir] - Recibe la tasa a corregir
 */
const TablaTiposCambio = ({ tasas, onCorregir }) => (
    <div className="invext-tc-table-wrap">
        <table className="invext-tc-table">
            <thead>
                <tr>
                    <th>Moneda</th>
                    <th className="num">Pesos por unidad</th>
                    <th>Vigencia</th>
                    <th>Fuente</th>
                    {onCorregir && <th aria-label="Acciones" />}
                </tr>
            </thead>
            <tbody>
                {tasas.map((tasa) => (
                    <tr key={tasa.id}>
                        <td className="moneda">{tasa.moneda}</td>
                        <td className="num">${formatearValor(tasa.valor_clp)}</td>
                        <td>{formatearFecha(tasa.fecha_vigencia)}</td>
                        <td>{tasa.fuente}</td>
                        {onCorregir && (
                            <td className="acciones">
                                <button type="button" className="invext-btn-sec" onClick={() => onCorregir(tasa)}>
                                    Corregir
                                </button>
                            </td>
                        )}
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export default TablaTiposCambio;
